import { useMemo } from 'react'
import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles'
import { useThemeMode, buildAppTheme } from '../../context/ThemeContext'
import { DEFAULT_PALETTE_ID } from '../../lib/brandPalettes'

/**
 * Applies the selected brand palette preset to everything inside it.
 *
 * Mounted only inside the `/super-admin/*` route tree, so the palette structurally
 * cannot affect other portals. To extend palette support to another view later (e.g.
 * Account Manager), wrap that route tree in this same component.
 */
export const SuperAdminThemeScope = ({ children }) => {
  const { mode, superAdminPalette } = useThemeMode()

  const theme = useMemo(
    () => (superAdminPalette === DEFAULT_PALETTE_ID ? null : buildAppTheme(mode, superAdminPalette)),
    [mode, superAdminPalette],
  )

  if (!theme) return children
  return <MUIThemeProvider theme={theme}>{children}</MUIThemeProvider>
}
